/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { assetsBatchesUrls, listMultipleAssetsUrls, samsBuildBatchesUrls } from '@/configs/urls'

export const urlsByProcessType = {
  ASSET_LISTING_BATCH: `/${listMultipleAssetsUrls.base}`,
  ASSETS_BATCH_CREATING: `/${assetsBatchesUrls.base}`,
  ASSETS_BATCH_PROCESSING: `/${assetsBatchesUrls.base}`,
  SAM_BUILD_BATCH: `/${samsBuildBatchesUrls.base}`
}

export const labelByProcessType = {
  ASSET_LISTING_BATCH: 'View Listing Batch',
  ASSETS_BATCH_PROCESSING: 'View Asset Batch',
  ASSETS_BATCH_CREATING: 'View Asset Batch',
  SAM_BUILD_BATCH: 'View SAM Build Batch'
}

export const batchLabelByProcessType = {
  ASSET_LISTING_BATCH: 'Asset Listing Batch',
  ASSETS_BATCH_PROCESSING: 'Asset Batch',
  ASSETS_BATCH_CREATING: 'Asset Batch',
  SAM_BUILD_BATCH: 'SAM Build Batch'
}

export const processedLabelByProcessType = {
  ASSETS_BATCH_CREATING: 'Successfully registered'
}

export const batchProcessStatus = {
  ERROR: 'error',
  FAILED: 'error',
  PARTIAL: 'warning',
  PROCESSING: 'processing',
  SUCCESS: 'success'
}

export const getStatus = (status) => {
  return batchProcessStatus[status] || batchProcessStatus.PROCESSING
}
